
var breakPoint = 769;
$(function(){
  $(".MainViewWrap").addClass("is-start");
  animation();
  slickSlide();
});
$(window).on("resize load scroll",function() {
  animation();
  mainview();
});
const mediaQuery = window.matchMedia('(min-width:'+breakPoint+'px)');
handle(mediaQuery);
// ウィンドウサイズを変更しても実行（ブレイクポイントの監視）
mediaQuery.addListener(handle);
function handle(mq) {
  if (mq.matches) {
    // ウィンドウサイズ768px以上のときの処理
  } else {
    // それ以外の処理
  }
}
//メインビュー
function mainview() {
  var imgPos = $('.MainViewBg02').offset().top;
  var mvOffsetTop = $('.MainView').offset().top;
  var mvHeight = $('.MainView').innerHeight();
  var mvScrollTop = mvOffsetTop + mvHeight;
  var mvMainOffsetTop = $('.MainView__main').offset().top;
  var mvMainHeight = $('.MainView__main').innerHeight();
  var mvMainScrollTop = mvMainOffsetTop + mvMainHeight;
  var mvMainBgHeight = $('.MainViewBg').innerHeight();
  //  var windowHeight = $(window).height();
  var scroll = $(window).scrollTop();
  var bgScroll = parseInt( 0 - scroll / 30 );
  if (bgScroll > -30){
    $('.MainViewBg02 img').css('transform', 'translateY(' + bgScroll + '%)');
  } else {
    $('.MainViewBg02 img').css('transform', 'translateY(-30%)');
  }
  if (scroll > 10){
    //      $("img",this).addClass("is-active");
  } else {
    //      $("img",this).removeClass("is-active");
  }
  if(scroll > mvScrollTop) {
    $(".MainViewWrap").addClass("is-active");
  } else {
    $(".MainViewWrap").removeClass("is-active");
  }
  if(scroll > mvMainScrollTop) {
    $(".MainView").addClass("is-active");
    $(".MainViewBg02").addClass("is-active");
    $(".MainView__icon").addClass("is-hide");
  } else {
    $(".MainView").removeClass("is-active");
    $(".MainViewBg02").removeClass("is-active");
    $(".MainView__icon").removeClass("is-hide");
  }
  $(".MainViewWrap").css('padding-bottom',mvMainBgHeight);
}
//アニメーション
function animation() {
  $("[data-animation]").each(function() {
    var imgPos = $(this).offset().top;
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll > imgPos - windowHeight){
      $(this).attr('data-animation','true');
    }
  });
}
//スライド - slick
function slickSlide() {
  var width = $(window).width();
//  $(".SlideWrap__inner").attr('data-group', 'gallery-');
//  $('.Slide:not(".js-slick")').find(".Slide__item").wrap('<div>');
  $(".js-slick").each(function(i){
//    var gNumber = "gallery-"+i;
    //        var sectionId = $(this).closest(".shopify-section").attr('id');
    //        var uniqueClass = "js-slick--" + sectionId;
    var slideLength = $(this).find(".Slide__item").length;
//     $(".Slide__item",this).attr('data-group', gNumber);
    var slideSlot = $(this).attr('data-slot');
    if(width < breakPoint) {
      var slideShow = 1;
    } else {
      var slideShow = slideSlot;
    }
    if(slideLength <= slideShow) {
      var slideDotsState = false;
    } else {
      var slideDotsState = true;
    }
    //        $(this).addClass(uniqueClass);
    $(this).slick({
      autoplaySpeed: 2000,
      autoplay: true,
      dots: slideDotsState,
      appendDots: $(this).next(".SlideDots"),
      dotsClass: 'SlideDots__inner',
      arrows: false,
      draggable: false,
      //      prevArrow: '<div class="rollOver Slide__prev slideButton slideButton--prev"></div>',
      //      nextArrow: '<div class="rollOver Slide__next slideButton slideButton--next"></div>',
      slidesToShow: slideSlot,
      responsive: [{
        breakpoint: breakPoint,
        settings: {
          slidesToShow: 1,
          centerPadding: '20px',
          centerMode: true
        }
      }]
    });
  });
  $('.Slide__item[href]').modaal({
    type: 'image'
  });
}

(function () {
  // 全てのjs-toggleクラスを持つ要素を取得
  var toggleButtons = document.querySelectorAll(".js-toggle");

  // 初期状態で対象のtoggleコンテンツがis-activeクラスを持っているかどうかを確認し、ボタンにもis-activeクラスを追加
  toggleButtons.forEach(function (button) {
    var targetClass = button.getAttribute("data-toggle");
    var targetContent = document.querySelector("." + targetClass + ".toggle");

    if (targetContent && targetContent.classList.contains("is-active")) {
      button.classList.add("is-active");
    }
  });

  // 各ボタンに対してクリックイベントを追加
  toggleButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      // data-toggle属性の値を取得
      var targetClass = this.getAttribute("data-toggle");
      // 対応するコンテンツの要素を取得
      var targetContent = document.querySelector("." + targetClass + ".toggle");

      // 対応するコンテンツが存在する場合は、表示/非表示を切り替える
      if (targetContent) {
        // is-activeクラスを持っている場合は開いた状態にする
        var isActive = targetContent.classList.contains("is-active");

        // 連動するボタンにis-activeクラスを追加・削除
        toggleButtons.forEach(function (btn) {
          if (btn.getAttribute("data-toggle") === targetClass) {
            btn.classList.toggle("is-active", !isActive);
          } else {
            // btn.classList.remove('is-active');
          }
        });

        // is-activeクラスを持っている場合は閉じる、持っていない場合は開く
        if (isActive) {
          targetContent.style.maxHeight = null; // デフォルトのmax-heightを使用
        } else {
          targetContent.style.maxHeight = targetContent.scrollHeight + "px";
        }
        // is-activeクラスを付与/削除
        targetContent.classList.toggle("is-active", !isActive);
      }
    });
  });

  // 初期状態でis-activeクラスを持つコンテンツを開く
  var initiallyActiveContents = document.querySelectorAll(".toggle.is-active");
  initiallyActiveContents.forEach(function (content) {
    content.style.maxHeight = content.scrollHeight + "px";
  });
})();

// Item_DualLens モーダル実装
document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById("p-Dual_CheckModal");
  const openBtn = document.getElementById("p-Dual_OpenModal");
  
  // 閉じるための要素をまとめる（閉じるボタン2種 + リンクボタン）
  const closeElements = document.querySelectorAll("#p-Dual_CloseModal, #p-Dual_CloseModalBottom, .p-Dual_Modal__item");

  if (!modal || !openBtn) {
    console.warn("モーダルまたはボタンが見つかりません");
    return;
  }

  // モーダルを開く処理
  openBtn.addEventListener("click", function () {
    modal.style.display = "block";
    document.body.style.overflow = "hidden";
  });

  // モーダルを閉じる処理（バツボタン、閉じるボタン、リンクボタン共通）
  closeElements.forEach((element) => {
    if (element) {
      element.addEventListener("click", function () {
        modal.style.display = "none";
        document.body.style.overflow = "auto";
        // リンクボタンの場合は、この後HTMLのhrefに従ってページ内リンクへ飛びます
      });
    }
  });
});


//白内障LP スライド

document.addEventListener("DOMContentLoaded", function () {
	  const slider = document.querySelector(".p-cataract_slider");
	  const dots = document.querySelectorAll(".p-cataract_dots .dot");
	  const slides = document.querySelectorAll(".p-cataract_hikaku_imgbox");

	  if (!slider || !dots.length) return;

	  slider.addEventListener("scroll", () => {
		const scrollLeft = slider.scrollLeft;
		const width = slider.clientWidth;
		const index = Math.round(scrollLeft / width);

		dots.forEach((dot, i) => {
		  dot.classList.toggle("active", i === index);
		});
	  });
	});

 //共通スライド

document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".p-tlx-achieve_sld");
  const dots = document.querySelectorAll(".p-tlx-achieve_dots .dot");
  const slides = document.querySelectorAll(".p-tlx-achieve_sldbox");

	  if (!slider || !dots.length) return;

	  slider.addEventListener("scroll", () => {
		const scrollLeft = slider.scrollLeft;
		const width = slider.clientWidth;
		const index = Math.round(scrollLeft / width);

		dots.forEach((dot, i) => {
		  dot.classList.toggle("active", i === index);
		});
	  });
	});

 // 開閉エリア
document.addEventListener('DOMContentLoaded', function () {
  const hideWraps = document.querySelectorAll('.js-hide-wrap');
  hideWraps.forEach(function (wrap) {
    const readMoreBtn = wrap.querySelector('.js-readmore');
    if (readMoreBtn) {
      readMoreBtn.addEventListener('click', function () {
        wrap.classList.toggle('is-open');
        if (wrap.classList.contains('is-open')) {
          readMoreBtn.innerHTML = '閉じる <span>－</span>';
        } else {
          readMoreBtn.innerHTML = 'もっと見る <span>＋</span>';
        }
      });
    }
  });
});

// タブ切り替え
document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.js-tv-scene-tabs li');
  const panels = document.querySelectorAll('.p-tv_scene_panel');

  if (tabs.length > 0 && panels.length > 0) {
    tabs.forEach(tab => {
      tab.addEventListener('click', function () {
        tabs.forEach(t => t.classList.remove('is-active'));
        this.classList.add('is-active');
        panels.forEach(p => p.classList.remove('is-active'));
        const targetId = this.getAttribute('data-target');
        document.getElementById(targetId).classList.add('is-active');
      });
    });
  }
});

// LP内動画設置
function toggleMute(event, btn) {
  event.stopPropagation();
  const video = btn.parentElement.querySelector('video');
  video.muted = !video.muted;
  btn.classList.toggle('is-unmuted', !video.muted);
}


//HT modal
document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('step-modal');
  const openBtns = document.querySelectorAll('.p-ht_js-modal-open');
  const closeBtns = document.querySelectorAll('.p-ht_js-modal-close');

  // 「入力手順を詳しく見る」をクリックした時の処理（開く）
  openBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault(); // aタグのリンク遷移を無効化
      modal.classList.add('is-active');
    });
  });

  // 「閉じる」ボタン、または背景黒枠をクリックした時の処理（閉じる）
  closeBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      modal.classList.remove('is-active');
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const codeBoxes = document.querySelectorAll('.p-ht_camp_code_box');

  codeBoxes.forEach(box => {
    box.addEventListener('click', () => {
      const text = box.textContent.trim();
      navigator.clipboard.writeText(text).then(() => {
        alert('「' + text + '」をコピーしました');
      });
    });
  });
});